import '../styles/styleHeader.css'

export default function Header(){
    return <div className='headerContainer'>
        <h1>TRIPLEY</h1>
    </div>
}